if (!customElements.get('collection-grid-slider')) {
  class CollectionGridSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      this.swiper = new Swiper(this.querySelector('.collection-grid-slider'), {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,

        breakpoints: {
          0: {
            slidesPerView: 1.2
          },
          580: {
            slidesPerView: 1.9
          },
          768: {
            slidesPerView: 2.4
          },
          1024: {
            slidesPerView: 4
          }
        }
      });
    }
  }

  customElements.define('collection-grid-slider', CollectionGridSlider);
}
